import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Beforeunload } from "react-beforeunload";
import logo from "../Assets/bg.jpg";
import TicketCanvas from "../Components/ticketCanvas";

import {
  Badge,
  Calendar,
  Layout,
  Menu,
  Drawer,
  List,
  Input,
  Button,
  Select,
  Spin,
  Modal,
  Image,
} from "antd";
import {
  SearchOutlined,
  CalendarOutlined,
  MenuOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  PieChartOutlined,
  DashboardOutlined,
  PicLeftOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { SpaceBetween } from "@cloudscape-design/components";

const { Header, Sider, Content, Footer } = Layout;

const contentStyle = {
  padding: 50,
  background: "rgba(0, 0, 0, 0.05)",
  borderRadius: 4,
};
const content = <div style={contentStyle} />;

function JobBoard() {
  const navigate = useNavigate();
  const handleMenuClick = (e) => {
    navigate(e.key); // e.key will be route path
  };
  const authIDToken = localStorage.getItem("idToken");
  process.env.NODE_ENV === "development"
    ? (document.title = "HS DEV MODE | Job Board")
    : (document.title = "Job Board | Hansoftware");

  const [searchTerm, setSearchTerm] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [calendarViewDate, setCalendarViewDate] = useState(dayjs());
  const [selectedMenuKey, setSelectedMenuKey] = useState("1");

  const [jobData, setJobData] = useState([]);
  const [jobDataLoading, setJobDataLoading] = useState(true);

  // MODAL
  const [selectedTickets, setSelectedTickets] = useState(new Set());
  const toggleViewTicket = (index) => {
    setSelectedTickets((prevSet) => {
      const nextSet = new Set(prevSet);
      if (nextSet.has(index)) {
        nextSet.delete(index); // Collapse if already open
      } else {
        nextSet.add(index); // Expand if closed
      }
      return nextSet;
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // GET AWS DATA (DYNAMO FROM LAMBDA)
  useEffect(() => {
    getJobTickets();
  }, []);

  const getJobTickets = async () => {
    setJobDataLoading(true);
    await axios
      .get("https://api.hansoftware.net/getJobTickets", {
        headers: {
          Authorization: `Bearer ${authIDToken}`, // from your Cognito login response
        },
      })
      .then((response) => {
        //console.log(response);
        if (response.status === 200) {
          //setJobData(response.data.itemArray);
          setJobDataLoading(false);
          // process data for calendar
          processJobData(response.data.itemArray);
          //console.log(response.data.itemArray);
        } else {
          // error
          setJobDataLoading(false);
          console.log("Error:" + response.data.err);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const processJobData = (jobInfo) => {
    var dataArr = [];
    //console.log(jobInfo);
    for (let row in jobInfo) {
      let key = jobInfo[row].DAUNKey;
      let desc = jobInfo[row].calendarDesc;
      let status = jobInfo[row].calendarStatus;
      if (status === "Scheduled") {
        status = "default";
      } else if (status === "In progress") {
        status = "warning";
      } else if (status === "Complete") {
        status = "success";
      } else {
        // cancelled or error
        status = "error";
      }
      let plumberArr = [];
      for (let object in jobInfo[row].selectedPlumbers) {
        plumberArr.push(jobInfo[row].selectedPlumbers[object].value);
      }
      let plumberArrString = plumberArr.join(", ");
      let plumbers = normalizePlumber(plumberArrString);

      let ticketData = {
        callDate: jobInfo[row].callDate,
        jobDate: jobInfo[row].jobDate,
        eta: jobInfo[row].eta,
        name: jobInfo[row].name,
        address: jobInfo[row].address,
        zipCode: jobInfo[row].zipCode,
        unit: jobInfo[row].unitNum,
        community: jobInfo[row].community,
        gateCode: jobInfo[row].gateCode,
        phoneNum: jobInfo[row].phoneNum,
        email: jobInfo[row].email,
        jobType: jobInfo[row].jobType,
        customJobType: jobInfo[row].customJobType,
        customJobLabel: jobInfo[row].customJobLabel,
        plumberSelected: jobInfo[row].plumberSelected,
        selectedPlumbers: jobInfo[row].selectedPlumbers,
        plumbers: plumbers,
        estJobTime: jobInfo[row].estJobTime,
        paymentType: jobInfo[row].paymentType,
        jobNotes1: jobInfo[row].jobNotes1,
        jobNotes2: jobInfo[row].jobNotes2,
        jobNotes3: jobInfo[row].jobNotes3,
        jobNotes4: jobInfo[row].jobNotes4,
        jobNotes5: jobInfo[row].jobNotes5,
        jobNotes6: jobInfo[row].jobNotes6,
        jobNotes7: jobInfo[row].jobNotes7,
        comments1: jobInfo[row].comments1,
        comments2: jobInfo[row].comments2,
      };
      const dayRegex =
        /\b(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)\b\s*/gi;
      let trimmedDate = ticketData.jobDate.replace(dayRegex, "");
      let obj = {
        date: trimmedDate,
        title: `${plumbers} • ${ticketData.eta} – ${ticketData.name}`,
        status: status,
        description: desc,
        ticket: ticketData,
        key: key,
      };

      dataArr.push(obj);
      //console.log(obj);
    }

    // sort list items by plumbers and timeframe
    dataArr.sort((a, b) => {
      console.log(a.ticket.plumbers);
      const plumberA = normalizePlumber(a.ticket.plumbers);
      const plumberB = normalizePlumber(b.ticket.plumbers);
      const plumberComparison = plumberA.localeCompare(plumberB);
      if (plumberComparison !== 0) {
        return plumberComparison;
      }

      return getStartHour(a.ticket.eta) - getStartHour(b.ticket.eta);
    });
    setJobData(dataArr);
  };

  const normalizePlumber = (plumberStr) => {
    return plumberStr
      .split(",")
      .map((name) => name.trim())
      .sort()
      .join(", ");
  };
  function getStartHour(timeStr) {
    // Split "11-2" into ["11", "2"] and take the first part
    let startStr = timeStr.split("-")[0];
    let hour = parseInt(startStr, 10);

    // Normalize 1-8 PM to 13-20 so they sort correctly after 12 (Noon)
    if (hour >= 1 && hour <= 8) {
      hour += 12;
    }

    return hour;
  }

  // CALENDAR FUNCTIONS
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const onSelectDate = (value, info) => {
    if (info?.source === "date") {
      setSelectedDate(value);
      setDrawerVisible(true);
    }
  };
  const handleEventClick = (dateStr) => {
    const day = dayjs(dateStr);
    setSelectedDate(day);
    setCalendarViewDate(day);
    setDrawerVisible(true);
  };
  const handleReset = () => {
    const today = dayjs();
    setCalendarViewDate(today);
    setSelectedDate(today);
    setDrawerVisible(false);
  };
  const onPanelChange = (value) => {
    setCalendarViewDate(value);
  };
  const getJobsByDate = (date) => {
    const dateStr = date.format("M/D/YY"); // DATE FORMAT
    return jobData.filter((job) => job.date === dateStr);
  };
  const dateCellRender = (value) => {
    const listData = getJobsByDate(value).filter(
      (job) =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.description.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    return (
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {listData.map((item, index) => (
          <li key={index}>
            <Badge
              status={item.status}
              text={item.title}
              style={{ paddingLeft: 4 }}
            />
          </li>
        ))}
      </ul>
    );
  };
  const selectedDateJobs = getJobsByDate(selectedDate);

  const menuItems = {
    1: "Calendar View",
    2: "Search Tickets",
    3: "Ticket View",
  };

  const CalendarContent = ({
    onSelectDate,
    searchTerm,
    setSearchTerm,
    filteredDates,
    handleEventClick,
  }) => (
    <div style={{ padding: 24, background: "#fff" }}>
      <Input.Search
        placeholder="Search jobs"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 16 }}
        allowClear
        autoFocus
      />
      {searchTerm && filteredDates.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h3>Matching Jobs</h3>
          <List
            itemLayout="horizontal"
            dataSource={filteredDates.flatMap((date) =>
              getJobsByDate(dayjs(date))
                .filter(
                  (job) =>
                    job.title
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    job.description
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()),
                )
                .map((job) => ({ ...job, date })),
            )}
            renderItem={(item) => (
              <List.Item
                onClick={() => handleEventClick(item.date)}
                style={{ cursor: "pointer" }}
              >
                <List.Item.Meta
                  title={item.title}
                  description={item.description}
                />
              </List.Item>
            )}
          />
        </div>
      )}
      {jobDataLoading ? (
        <Spin tip="Loading..." size="large">
          {content}
        </Spin>
      ) : (
        <Calendar
          value={calendarViewDate}
          cellRender={(value) => dateCellRender(value)}
          onSelect={onSelectDate}
          onPanelChange={onPanelChange}
          fullscreen
          headerRender={({ value, onChange }) => {
            const current = dayjs();
            const year = value.year();
            const month = value.month();

            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0 8px",
                }}
              >
                <div style={{ display: "flex", gap: 8 }}>
                  <Select
                    value={year}
                    onChange={(newYear) => {
                      const newDate = value.clone().year(newYear);
                      onChange(newDate);
                      setCalendarViewDate(newDate);
                    }}
                  >
                    {Array.from({ length: 20 }, (_, i) => {
                      const y = current.year() - 10 + i;
                      return (
                        <Select.Option key={y} value={y}>
                          {y}
                        </Select.Option>
                      );
                    })}
                  </Select>

                  <Select
                    value={month}
                    style={{ width: 100 }}
                    onChange={(newMonth) => {
                      const newDate = value.clone().month(newMonth);
                      onChange(newDate);
                      setCalendarViewDate(newDate);
                    }}
                  >
                    {Array.from({ length: 12 }, (_, i) => (
                      <Select.Option key={i} value={i}>
                        {dayjs().month(i).format("MMMM")}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <Button
                  onClick={() => {
                    const today = dayjs();
                    onChange(today);
                    setCalendarViewDate(today);
                    setSelectedDate(today);
                    setDrawerVisible(false);
                    setSearchTerm("");
                  }}
                >
                  Reset to Today
                </Button>
              </div>
            );
          }}
        />
      )}
    </div>
  );

  const SearchContent = () => (
    <div style={{ padding: 24, background: "#fff" }}>
      <h3>Search Job Tickets</h3>
      <p>Search for specific job tickets based on customer name and/or date.</p>
    </div>
  );

  const filteredDates = Array.from(
    new Set(
      jobData
        .filter(
          (event) =>
            event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            event.description.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((event) => event.date),
    ),
  );

  useEffect(() => {
    if (filteredDates.length > 0 && searchTerm) {
      const newDate = dayjs(filteredDates[0]);
      if (!calendarViewDate.isSame(newDate, "day")) {
        setCalendarViewDate(newDate);
      }
    }
  }, [searchTerm, filteredDates, calendarViewDate]);

  const renderContent = () => {
    switch (selectedMenuKey) {
      case "1":
        return (
          <CalendarContent
            onSelectDate={onSelectDate}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            filteredDates={filteredDates}
            handleEventClick={handleEventClick}
          />
        );
      case "2":
        return <SearchContent />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          style={{
            height: 32,
            margin: 16,
            color: "white",
            fontSize: 18,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {collapsed ? <MenuOutlined /> : "Menu"}
        </div>

        <Menu
          theme="dark"
          mode="inline"
          onClick={handleMenuClick}
          defaultSelectedKeys={["/dashboard/job-board"]}
          items={[
            {
              key: "/dashboard",
              icon: <PieChartOutlined />,
              label: "Dashboard",
            },
            {
              key: "/dashboard/job-board",
              icon: <DashboardOutlined />,
              label: "Job Board",
            },
            {
              key: "/dashboard/ticket-generator",
              icon: <PicLeftOutlined />,
              label: "Ticket Generator",
            },
            {
              key: "/dashboard/customer-list",
              icon: <UnorderedListOutlined />,
              label: "Customer List",
            },
          ]}
        />
      </Sider>
      <Layout>
        <Header style={{ background: "#fff", padding: 0 }}>
          <div style={{ paddingLeft: 16, fontSize: 18 }}>
            {collapsed ? (
              <DoubleRightOutlined onClick={toggleCollapsed} />
            ) : (
              <DoubleLeftOutlined onClick={toggleCollapsed} />
            )}
            <span style={{ marginLeft: 16 }}>{menuItems[selectedMenuKey]}</span>
          </div>
        </Header>
        <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
          {renderContent()}
        </Content>
        <Footer style={{ textAlign: "center" }}>© 2026 Hansoftware</Footer>

        <Drawer
          title={`Jobs on ${selectedDate.format("dddd, MMMM D, YYYY")}`}
          placement="right"
          width={600}
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
        >
          <List
            header={
              <div
                style={{
                  display: "grid",
                  fontWeight: "bold",
                  //padding: "0 16px",
                  gridTemplateColumns: "80px 1fr 2fr 2fr 60px", // Adjust proportions as needed
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div>Plumber</div>
                <div>ETA</div>
                <div>Customer</div>
                <div>Status</div>
                <div>Ticket</div>
              </div>
            }
            itemLayout="vertical"
            bordered
            dataSource={selectedDateJobs}
            renderItem={(item, index) => {
              const isSelected = selectedTickets.has(index);

              return (
                <List.Item
                  style={{
                    display: "grid",
                    gridTemplateColumns: "80px 1fr 2fr 2fr 60px", // Adjust proportions as needed
                    alignItems: "center",
                    width: "100%",
                    //padding: "12px 16px",
                  }}
                >
                  <div
                    style={
                      item.ticket.plumbers === "BH"
                        ? { color: "#4089ff", fontWeight: "bold" }
                        : item.ticket.plumbers === "BH, JH"
                          ? { color: "#9e0fdb", fontWeight: "bold" }
                          : item.ticket.plumbers === "JH"
                            ? { color: "#0ed6ae", fontWeight: "bold" }
                            : item.ticket.plumbers === "ES, JH"
                              ? { color: "#82e512", fontWeight: "bold" }
                              : item.ticket.plumbers === "BH, ES"
                                ? { color: "#e57112", fontWeight: "bold" }
                                : item.ticket.plumbers === "ES"
                                  ? { color: "#0ba845", fontWeight: "bold" }
                                  : { color: "#e5126a", fontWeight: "bold" }
                    }
                  >
                    {item.ticket.plumbers}
                  </div>
                  <div>{item.ticket.eta}</div>
                  <div>{item.ticket.name}</div>
                  <div>
                    <Badge
                      status={item.status}
                      text={
                        item.status === "default"
                          ? "Scheduled"
                          : item.status === "warning"
                            ? "In progress"
                            : item.status === "success"
                              ? "Complete"
                              : "Cancelled" // or error
                      }
                    />
                  </div>
                  <div>
                    <Button
                      type="primary"
                      onClick={() => {
                        toggleViewTicket(index);
                      }}
                      //style={{ marginTop: 8 }}
                    >
                      {isSelected ? "Hide" : "Show"}
                    </Button>
                  </div>
                  <List.Item.Meta
                    style={{ marginTop: 10 }}
                    title={item.name}
                    description={
                      isSelected ? (
                        <>
                          <TicketCanvas data={item.ticket} />
                          <Button
                            type="primary"
                            danger
                            onClick={() => {
                              // send to Job Ticket page
                              navigate("../ticket-generator", {
                                state: {
                                  ticketData: item,
                                  from: "job-board",
                                },
                              });
                            }}
                            style={{ padding: 15, width: 440 }}
                          >
                            Edit ticket
                          </Button>
                        </>
                      ) : null
                    }
                  />
                </List.Item>
              );
            }}
          />
        </Drawer>
      </Layout>
    </Layout>
  );
}

export default JobBoard;
